// import { useMenu } from '../../hooks/InboxHubHooks'
import { LinkedInChatReplyIcon } from 'src/assets/inboxHub/InboxHubIcons'
import { Avatar, Box, Stack, Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'

function LinkedInMessage ({ messageId, isMe, body, time, reaction, showPhoto, photoUrl, replyOf, handleReplyingOfMessage, handleReactOnMessage, chatName }) {
  // const {
  //   anchorEl,
  //   open,
  //   handleClick,
  //   handleClose
  // } = useMenu()
  const reactionValue = [...reaction].find(reac => isMe ? !reac.is_sender : reac.is_sender)
  return (
    <Stack key={messageId} direction={!isMe ? 'row' : 'row-reverse'} justifyContent={isMe ? 'end' : 'start'} sx={{ width: '100%' }} py={0.5}>
      <Box sx={{ display: 'flex', justifyContent: !isMe ? 'flex-start' : 'flex-end', width: '3rem' }}>
        {
          showPhoto && <Avatar src={photoUrl} alt='User' />
        }
      </Box>
      <Stack maxWidth='60%' gap={0.5} alignItems={!isMe ? 'start' : 'end'} position='relative'>
        {replyOf &&
          (
            <Box
              sx={
                {
                  backgroundColor: 'rgb(240, 240, 240)',
                  border: '1px solid rgb(231, 231, 231)',
                  p: 1,
                  borderRadius: 3,
                  marginBottom: -1
                }
              }
            >
              <Typography fontWeight={600} color='rgb(99, 99, 99)' fontSize='14px'>
                {replyOf.isMe ? 'You' : chatName}
              </Typography>
              <Typography color='rgb(145, 145, 145)' fontSize='12px'>
                {replyOf.body}
              </Typography>
            </Box>
          )}
        <Stack
          gap={1}
          direction={!isMe ? 'row' : 'row-reverse'}
          alignItems='center'
        >
          <Box position='relative'>

            <Typography sx={{
              width: '100%',
              textWrap: 'wrap',
              wordBreak: 'break-word',
              paddingY: 1,
              paddingX: 2,
              backgroundColor: !isMe ? 'rgb(26, 99, 255)' : 'rgb(228, 228, 228)',
              borderRadius: 2,
              color: !isMe ? '#FFFFFF' : 'rgb(41, 41, 41)',
              boxShadow: `0px 5px 10px ${!isMe ? 'rgba(26, 99, 255, 0.42)' : 'rgba(24, 24, 24, 0.17)'}`
            }}
            >
              {body}
            </Typography>
            {
              reactionValue &&
              (
                <Box
                  onClick={() => {
                    if (!isMe) {
                      handleReactOnMessage(messageId, null)
                    }
                  }}
                  sx={
                    !isMe
                      ? { ...reactionStyles, right: 0 }
                      : {
                          ...reactionStyles, left: 0
                        }
                  }
                >
                  {reactionValue?.value}
                </Box>
              )
            }
          </Box>
          <Stack gap={0} alignItems={!isMe ? 'start' : 'end'}>
            <Typography
              noWrap
              fontWeight={500}
              fontSize={10}
              sx={{
                color: 'rgba(41, 41, 41, 0.2)'
              }}
            >
              {moment(time).format('DD MMM YY')}{}

            </Typography>
            <Typography
              fontWeight={500}
              fontSize={10}
              sx={{
                color: 'rgba(41, 41, 41, 0.2)'
              }}
            >

              {moment(time).format('h:mma')}
            </Typography>
          </Stack>
        </Stack>
        <Stack direction='row' gap={1} width='fit-content'>
          <Box
            onClick={() => { handleReplyingOfMessage(messageId) }}
            sx={{
              cursor: 'pointer',
              transition: 'ease-in-out',
              '&:hover': {
                transform: 'scale(1.09)'
              }
            }}
          >
            <LinkedInChatReplyIcon />
          </Box>
          {
            // !isMe &&
            // (
            //   <Box
            //     sx={
            //       {
            //         cursor: 'pointer',
            //         transition: 'ease-in-out',
            //         '&:hover': {
            //           transform: 'scale(1.09)'
            //         }
            //       }
            //     }
            //     onClick={(e) => { handleClick(e) }}
            //   >
            //     <LinkedInMessageReactIcon />
            //   </Box>
            // )
          }
        </Stack>
      </Stack>

      {/* <Menu
        id='reactions-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Stack direction='row' gap={3} px={2}>
          {
            ['like', 'haha', 'sad', 'wow', 'angry'].map(
              (reaction, j) => (
                <Box
                  key={j}
                  onClick={() => {
                    handleReactOnMessage(messageId, reaction)
                    handleClose()
                  }}
                  sx={{ cursor: 'pointer', '&:hover': { scale: '1.2' } }}
                >
                  <ReactionHappy />
                </Box>
              )
            )
          }
        </Stack>
      </Menu> */}
    </Stack>
  )
}

export default LinkedInMessage

const reactionStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  bottom: '0%',
  translate: '0% 50%',
  width: '20px',
  height: '20px',
  padding: '2px',
  borderRadius: 20,
  backgroundColor: 'rgb(255, 255, 255)'
}
